import React from 'react';
import TablaGenerales from './TablaGenerales';

const DatosGenerales =(props)=>{
    return(
        <section className="datosGeneralesTotal">
            <TablaGenerales data={props.data} nomenclator={props.nomenclator} ini={props.ini} className='container content'/>
        </section>
    );
};

export default DatosGenerales;